export default "__VITE_ASSET__ff136edb__"